import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_CONSULTANT_COOPTATIONS = gql`
    query GetConsultantCooptations($uuid: ID!) {
        user(uuid: $uuid) {
            uuid
            firstname
            lastname
            cooptedBy {
                cooptant {
                    uuid
                    firstname
                    lastname
                }
                monthsDuration
                percentage
                startDate
            }
        }
    }
`;

const useConsultantCooptations = (uuid) => {
    const { loading, error, data, refetch } = useQuery(GET_CONSULTANT_COOPTATIONS, {
        variables: { uuid },
        skip: !uuid,
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.user,
        loading,
        error,
        refetch,
    };
};

export default useConsultantCooptations;
